import { render } from "./PartyEdit.vue?vue&type=template&id=2b3263d0"
import script from "./PartyEdit.vue?vue&type=script&lang=js"
export * from "./PartyEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__